var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useRef } from 'react';
import { Box } from "./..";
import { useToggle } from "../../hooks";
import { useDropdownToggle, DropdownContent } from './';
import { DropdownButton } from './DropdownButton';
export var ControlledDropdown = function (_a) {
    var props = __rest(_a, []);
    var _b = __read(useToggle(false), 2), isOpen = _b[0], onToggle = _b[1];
    return (React.createElement(UncontrolledDropdown, __assign({ isOpen: isOpen, onToggle: onToggle }, props)));
};
export var UncontrolledDropdown = function (_a) {
    var id = _a.id, label = _a.label, render = _a.render, children = _a.children, disabled = _a.disabled, isOpen = _a.isOpen, onToggle = _a.onToggle, _b = _a.showToggleIndicator, showToggleIndicator = _b === void 0 ? false : _b, _c = _a.isOutlineToggle, isOutlineToggle = _c === void 0 ? false : _c, _d = _a.buttonProps, buttonProps = _d === void 0 ? {} : _d, _e = _a.contentProps, contentProps = _e === void 0 ? {} : _e, _f = _a.disableBackdrop, disableBackdrop = _f === void 0 ? false : _f, isResponsive = _a.isResponsive, lss = _a.lss, ariaLabel = _a.ariaLabel, _g = _a.removeContentOnClose, removeContentOnClose = _g === void 0 ? true : _g, _h = _a.isInlineDropdown, isInlineDropdown = _h === void 0 ? false : _h;
    var node = useRef(null);
    var _j = useDropdownToggle({
        node: node,
        isOpen: isOpen,
        onToggle: onToggle,
        disableBackdrop: disableBackdrop
    }), onOpen = _j.onOpen, onClose = _j.onClose;
    var renderContent = removeContentOnClose ? isOpen : true;
    return (React.createElement(Box, { ref: node, lss: __assign(__assign({ position: 'relative', mx: 'xs' }, (isInlineDropdown && { bg: 'primary500' })), lss) },
        React.createElement(DropdownButton, __assign({ label: label, showToggleIndicator: showToggleIndicator, isOutlineToggle: isOutlineToggle, isFullscreen: isInlineDropdown, id: id, type: "button", isOpen: isOpen, disabled: disabled, ariaLabel: ariaLabel }, buttonProps, { onClick: function () {
                isOpen ? onClose() : onOpen();
            } })),
        renderContent && (React.createElement(DropdownContent, __assign({}, contentProps, { render: children || render, disableBackdrop: disableBackdrop, "aria-labelledby": ariaLabel, isResponsive: isResponsive, isOpen: isOpen, isInlineDropdown: isInlineDropdown })))));
};
/**
 * This component can work both in an uncontrolled fashion by passing a boolean value to the isExpanded prop
 * or it can be controlled when not passing an isExpanded prop
 */
export var Dropdown = function (_a) {
    var props = __rest(_a, []);
    return typeof props.isOpen === 'boolean' ? (React.createElement(UncontrolledDropdown, __assign({}, props))) : (React.createElement(ControlledDropdown, __assign({}, props)));
};
//# sourceMappingURL=Dropdown.js.map